// Imports
import { createGlobalStyle } from 'styled-components/macro';
import useIsPageEditorRoute from '../../hooks/use-is-page-editor-route';


// Styled components
const GlobalStyle = createGlobalStyle`
	div[class^="sidebar__Container"] {
		display: none;
	}
	
	div[class^="top-bar__Container"] {
		display: none;
	}
	
	div[class^="content__Wrapper"] {
		margin-left: 0 !important;
		max-width: 100% !important;
	}
`;


// Function component
const CustomizePageEditorUI: React.FC = () => {
	// Detect what kind of route we are on
	const isPageEditorRoute = useIsPageEditorRoute();
	
	
	// Return
	return isPageEditorRoute ? <GlobalStyle /> : null;
};

export default CustomizePageEditorUI;
